// components/common/VarianceTooltip.jsx

import { Tooltip } from "primereact/tooltip";
import React, { useId } from "react";

const HeadingTooltip = ({
    targetClass='custom-headingTooltip',
    description='-',
    formula='-',
    children
}) => {
    const tooltipId = useId().replace(/:/g, "");
    const targetclass = `${targetClass}${tooltipId}`
    // ✅ add tooltip class automatically
    const childWithClass = React.cloneElement(children, {
        className: `${children.props.className || ""} cursor-pointer ${targetclass}`
    });
    return (
        <>
            <Tooltip
                style={{ cursor: "pointer" }}
                className="custom-tooltip-heading"
                target={`.${targetclass}`}
                position="left"
                my="left-15"
            >
                <div className="max-w-[400px] break-words whitespace-normal">
                    {/* <!-- Description --> */}
                    {description && (
                        <div className="mb-3">
                            <h3 className="text-sm font-semibold text-white mb-1">Description:</h3>
                            <p className="text-sm text-white leading-relaxed">
                                {description}
                            </p>
                        </div>
                    )}

                    {/* <!-- Divider --> */}
                    {/* <div className="border-t border-gray-200 my-2"></div> */}

                    {/* <!-- Formula --> */}
                    {formula && (
                        <div>
                            <h3 className="text-sm font-semibold text-white mb-1">Formula:</h3>
                            <p className="text-sm text-white leading-relaxed">
                                {formula}
                            </p>
                        </div>
                    )}
                </div>
            </Tooltip>

            {childWithClass}
        </>
    );
};

export default HeadingTooltip;
